import React from 'react';
import { Switch } from '@chakra-ui/react';


export default function LaunchdeckSwitch({name, isChecked, onChange, yesContent, noContent, yesBg, noBg, buttonWidth, additionalDistance}) {
	
	const displayedYesContent = yesContent || "";
	const displayedNoContent = noContent || "";
	const toggleMoveDistance = additionalDistance ? 2.5 + additionalDistance : 2.5;

	return (
		<Switch
		name={name || "default-switch"}
		isChecked={isChecked}
		value={isChecked}
		onChange={onChange}
		sx={{
				".chakra-switch__track::after": {
					// content: `"${isChecked ? displayedYesContent : displayedNoContent}"`,
					content: isChecked ? `${displayedYesContent}` : `${displayedNoContent}`,
					color: isChecked ? 'white' : 'brandDark.500',
					bg: isChecked ? `${yesBg || 'brand.500'}` : `${noBg || 'gray.200'}`,
					display: "block",
					position: "absolute",
					transform: "translate(-50%,-50%)",
					lineHeight: "1.5rem",
					top: "1em",
					left: isChecked ? "38%" : "70%",
					fontWeight: "400",
					fontSize: "0.8em"
				},
				".chakra-switch__track": {
					bg: isChecked ? `${yesBg || 'brand.500'}` : `${noBg || 'gray.200'}`,
					width: buttonWidth || "3.5em",
					height: "1.5em",
					px:'0.5em'
				},
				".chakra-switch__thumb": {
					width: "1.1em",
					height: "1.1em",
					mt:'0.2em',
					bg: !isChecked && "gray.700",
					_checked: {
						transform: `translateX(${toggleMoveDistance}em)`
					},
					zIndex: "5"
				}
		}}
	/>

	)
	
}
